import React from 'react';
import './WhyUs.css';

const reasons = [
  { icon: '🏆', title: 'Award-Winning Agency', desc: 'Recognized as Malaysia\'s top study abroad consultancy for 3 consecutive years.' },
  { icon: '🌐', title: 'Global Network', desc: 'Direct partnerships with 200+ universities across 10+ countries.' },
  { icon: '👨‍🏫', title: 'Expert Counsellors', desc: 'Our team includes alumni from UK, Canada, Australia, and US universities.' },
  { icon: '📊', title: '98% Visa Success', desc: 'Our meticulous documentation and preparation ensures near-perfect visa approvals.' },
  { icon: '💸', title: 'No Hidden Fees', desc: 'Transparent pricing. Most of our services are FREE — universities pay us.' },
  { icon: '🔒', title: 'Trusted & Verified', desc: 'Licensed education agency. Verified by Ministry of Education Malaysia.' },
];

export default function WhyUs() {
  return (
    <section className="why-us" id="why-us">
      <div className="section-inner">
        <div className="why-us-layout">
          <div className="why-us-left">
            <span className="section-tag">Why EduGlobe</span>
            <h2 className="section-title">The Agency That <span className="gold-text">Goes Further</span></h2>
            <p className="section-sub" style={{ textAlign: 'left', maxWidth: '100%' }}>
              Hundreds of agencies exist — but none match our combination of expertise, transparency, and genuine student-first approach. We don't just process applications. We change lives.
            </p>
            <div className="trust-bar">
              <div className="trust-item">
                <span className="trust-flag">🇲🇾</span>
                <span>Based in Malaysia</span>
              </div>
              <div className="trust-item">
                <span className="trust-flag">✅</span>
                <span>MOE Licensed</span>
              </div>
              <div className="trust-item">
                <span className="trust-flag">🌍</span>
                <span>Global Reach</span>
              </div>
            </div>
            <a href="#contact" className="btn-primary" style={{ display: 'inline-flex', marginTop: '1.5rem' }}>
              Meet Our Team <span className="btn-arrow">→</span>
            </a>
          </div>

          <div className="why-us-right">
            {reasons.map((r, i) => (
              <div className="reason-card" key={i}>
                <span className="reason-icon">{r.icon}</span>
                <div>
                  <h4 className="reason-title">{r.title}</h4>
                  <p className="reason-desc">{r.desc}</p>
                </div>
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}
